define(["exports", "hyperhtml", "../../core/utils", "../../core/pubsubhub", "./show-link", "./show-logo", "./show-people"], function (_exports, _hyperhtml, _utils, _pubsubhub, _showLink, _showLogo, _showPeople) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);
  _showLink = _interopRequireDefault(_showLink);
  _showLogo = _interopRequireDefault(_showLogo);
  _showPeople = _interopRequireDefault(_showPeople);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject23() {
    const data = _taggedTemplateLiteral(["\n    Some Rights Reserved: this document is dual-licensed,\n    ", " and\n    ", ".\n  "]);

    _templateObject23 = function _templateObject23() {
      return data;
    };

    return data;
  }

  function _templateObject22() {
    const data = _taggedTemplateLiteral(["\n            ", " &amp;\n          "]);

    _templateObject22 = function _templateObject22() {
      return data;
    };

    return data;
  }

  function _templateObject21() {
    const data = _taggedTemplateLiteral(["\n    <p class=\"copyright\">\n      <a href=\"https://www.w3.org/Consortium/Legal/ipr-notice#Copyright\"\n        >Copyright</a\n      >\n      &copy;\n      ", "", "\n      ", "\n      <a href=\"https://www.w3.org/\"\n        ><abbr title=\"World Wide Web Consortium\">W3C</abbr></a\n      ><sup>&reg;</sup> (<a href=\"https://www.csail.mit.edu/\"\n        ><abbr title=\"Massachusetts Institute of Technology\">MIT</abbr></a\n      >,\n      <a href=\"https://www.ercim.eu/\"\n        ><abbr\n          title=\"European Research Consortium for Informatics and Mathematics\"\n          >ERCIM</abbr\n        ></a\n      >, <a href=\"https://www.keio.ac.jp/\">Keio</a>,\n      <a href=\"https://ev.buaa.edu.cn/\">Beihang</a>). ", "\n      W3C <a href=\"", "\">liability</a>,\n      <a href=\"", "\">trademark</a> and ", " rules\n      apply.\n    </p>\n  "]);

    _templateObject21 = function _templateObject21() {
      return data;
    };

    return data;
  }

/* EEA specStatus */
    function _templateObject21eea() {
    const data = _taggedTemplateLiteral(["<p class=\"copyright\">Copyright &copy; ", "", "", "\n      <a href=\"https://entethalliance.org/\"\n        >Enterprise Ethereum Alliance</a>. ", "", "", "", ""]);

    _templateObject21eea = function _templateObject21eea() {
      return data;
    };

    return data;
  }

  function _templateObject20() {
    const data = _taggedTemplateLiteral(["\n          <p class=\"copyright\">\n            This document is licensed under a\n            ", ".\n          </p>\n        "]);

    _templateObject20 = function _templateObject20() {
      return data;
    };

    return data;
  }

  function _templateObject19() {
    const data = _taggedTemplateLiteral(["\n          <p class=\"copyright\">", "</p>\n        "]);

    _templateObject19 = function _templateObject19() {
      return data;
    };

    return data;
  }

  function _templateObject18() {
    const data = _taggedTemplateLiteral(["\n    <a rel=\"license\" href=\"", "\" class=\"", "\">", "</a>\n  "]);

    _templateObject18 = function _templateObject18() {
      return data;
    };

    return data;
  }

  function _templateObject17() {
    const data = _taggedTemplateLiteral(["\n            <p>\n              ", "\n              ", "\n            </p>\n          "]);

    _templateObject17 = function _templateObject17() {
      return data;
    };

    return data;
  }

  function _templateObject16() {
    const data = _taggedTemplateLiteral(["\n            <p>\n              See also\n              <a\n                href=\"", "\"\n              >\n                <strong>translations</strong></a\n              >.\n            </p>\n          "]);

    _templateObject16 = function _templateObject16() {
      return data;
    };

    return data;
  }

  function _templateObject15() {
    const data = _taggedTemplateLiteral(["\n            <p>\n              Please check the\n              <a href=\"", "\"><strong>errata</strong></a> for any\n              errors or issues reported since publication.\n            </p>\n          "]);

    _templateObject15 = function _templateObject15() {
      return data;
    };

    return data;
  }

  function _templateObject14() {
    const data = _taggedTemplateLiteral(["\n              <dt>\n                ", "\n              </dt>\n              ", "\n            "]);

    _templateObject14 = function _templateObject14() {
      return data;
    };

    return data;
  }

  function _templateObject13() {
    const data = _taggedTemplateLiteral(["\n              <dt>\n                ", "\n              </dt>\n              ", "\n            "]);

    _templateObject13 = function _templateObject13() {
      return data;
    };

    return data;
  }

  function _templateObject12() {
    const data = _taggedTemplateLiteral(["\n              <dt>Latest Recommendation:</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject12 = function _templateObject12() {
      return data;
    };

    return data;
  }

  function _templateObject11() {
    const data = _taggedTemplateLiteral(["\n              <dt>Previous Recommendation:</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject11 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10() {
    const data = _taggedTemplateLiteral(["\n              <dt>Previous version:</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject10 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["\n              <dt>Previous editor's draft:</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["\n              <dt>", "</dt>\n              <dd>", "</dd>\n            "]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["\n              <dt>Implementation report:</dt>\n              <dd>\n                <a href=\"", "\"\n                  >", "</a\n                >\n              </dd>\n            "]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n              <dt>Test suite:</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["\n              <dt>", "</dt>\n              <dd><a href=\"", "\">", "</a></dd>\n            "]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n                      <a href=\"", "\">", "</a>\n                    "]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n              <dt>", "</dt>\n              <dd>\n                <a class=\"u-url\" href=\"", "\"\n                  >", "</a\n                >\n              </dd>\n              <dt>", "</dt>\n              <dd>\n                ", "\n              </dd>\n            "]); 

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

/* EEA specStatus 
   Remove the empty <dt> and <dd> elements for the "This version" and "Previous version" headings */
  function _templateObject3eea() {
    const data = _taggedTemplateLiteral(["", "", "", "", "", ""]);

    _templateObject3eea = function _templateObject3eea() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n    <div class=\"head\">\n      ", " ", "\n      ", "\n      <h2>\n        ", "", "\n        <time class=\"dt-published\" datetime=\"", "\"\n          >", "</time\n        >\n      </h2>\n      <dl>\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        <dt>", "</dt>\n        ", "\n        ", "\n        ", "\n        ", "\n      </dl>\n      ", "\n      ", "\n      ", "\n      ", "\n      <hr title=\"Separator for header\" />\n    </div>\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n      Preview of PR <a href=\"", "\">#", "</a>:\n    "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const ccLicense = "https://creativecommons.org/licenses/by/4.0/";
  const w3cLicense = "https://www.w3.org/Consortium/Legal/copyright-documents";
  const legalDisclaimer = "https://www.w3.org/Consortium/Legal/ipr-notice#Legal_Disclaimer";
  const w3cTrademark = "https://www.w3.org/Consortium/Legal/ipr-notice#W3C_Trademarks";
/* EEA specStatus */
  const eealegalDisclaimer = "";
  const eeaTrademark = "";

  function getSpecTitleElem(conf) {
    const specTitleElem = document.querySelector("h1#title") || document.createElement("h1");

    if (specTitleElem.parentElement) {
      specTitleElem.remove();
    } else {
      specTitleElem.textContent = conf.title;
      specTitleElem.id = "title";
    }

    if (conf.isPreview && conf.prNumber) {
      const {
        childNodes
      } = (0, _hyperhtml.default)(_templateObject(), conf.prUrl, conf.prNumber);
      specTitleElem.prepend(...childNodes);
    }

    conf.title = (0, _utils.norm)(specTitleElem.textContent);
    specTitleElem.classList.add("title", "p-name");

    if (document.querySelector("title") === null) {
      document.title = conf.title;
    } else if (document.title !== conf.title) {
      (0, _pubsubhub.pub)("warn", "The document's title and the `<title>` element differ.");
    }

    return specTitleElem;
  }

  function getSpecSubTitleElem(conf) {
    let specSubTitleElem = document.querySelector("h2#subtitle");

    if (specSubTitleElem && specSubTitleElem.parentElement) {
      specSubTitleElem.remove();
      conf.subtitle = specSubTitleElem.textContent.trim();
    } else if (conf.subtitle) {
      specSubTitleElem = document.createElement("h2");
      specSubTitleElem.textContent = conf.subtitle;
      specSubTitleElem.id = "subtitle";
    }

    if (specSubTitleElem) {
      specSubTitleElem.classList.add("subtitle");
    }

    return specSubTitleElem;
  }

  var _default = conf => {
/*  EEA specStatus 
    Remove unwanted headings */
    if (conf.specStatus === "EEA") {
      return (0, _hyperhtml.default)(_templateObject2(), conf.logos.map(_showLogo.default), getSpecTitleElem(conf), ""                       , ""                           , conf.textStatus, conf.dashDate, conf.publishHumanDate, !conf.isNoTrack ? (0, _hyperhtml.default)(_templateObject3eea(), ""                    , ""              , ""              , ""                                , ""                 ? (0, _hyperhtml.default)(_templateObject4(), conf.latestVersion, conf.latestVersion) : ""    ) : "", conf.edDraftURI ? (0, _hyperhtml.default)(_templateObject5(), conf.l10n.latest_editors_draft, conf.edDraftURI, conf.edDraftURI) : "", conf.testSuiteURI ? (0, _hyperhtml.default)(_templateObject6(), conf.testSuiteURI, conf.testSuiteURI) : "", conf.implementationReportURI ? (0, _hyperhtml.default)(_templateObject7(), conf.implementationReportURI, conf.implementationReportURI) : "", conf.bugTrackerHTML ? (0, _hyperhtml.default)(_templateObject8(), conf.l10n.bug_tracker, [conf.bugTrackerHTML]) : "", conf.isED && conf.prevED ? (0, _hyperhtml.default)(_templateObject9(), conf.prevED, conf.prevED) : "", conf.showPreviousVersion ? (0, _hyperhtml.default)(_templateObject10(), conf.prevVersion, conf.prevVersion) : "", !conf.prevRecURI ? "" : conf.isRec ? (0, _hyperhtml.default)(_templateObject11(), conf.prevRecURI, conf.prevRecURI) : (0, _hyperhtml.default)(_templateObject12(), conf.prevRecURI, conf.prevRecURI), conf.multipleEditors ? conf.l10n.editors : conf.l10n.editor, (0, _showPeople.default)(conf.editors), Array.isArray(conf.formerEditors) && conf.formerEditors.length > 0 ? (0, _hyperhtml.default)(_templateObject13(), conf.multipleFormerEditors ? conf.l10n.former_editors : conf.l10n.former_editor, (0, _showPeople.default)(conf.formerEditors)) : "", conf.authors ? (0, _hyperhtml.default)(_templateObject14(), conf.multipleAuthors ? conf.l10n.authors : conf.l10n.author, (0, _showPeople.default)(conf.authors)) : "", conf.otherLinks ? conf.otherLinks.map(_showLink.default) : "", conf.errata ? (0, _hyperhtml.default)(_templateObject15(), conf.errata) : "", conf.isRec ? (0, _hyperhtml.default)(_templateObject16(), "http://www.w3.org/2003/03/Translations/byTechnology?technology=".concat(conf.shortName)) : "", conf.alternateFormats ? (0, _hyperhtml.default)(_templateObject17(), conf.multipleAlternates ? "This document is also available in these non-normative formats:" : "This document is also available in this non-normative format:", [conf.alternatesHTML]) : "", renderCopyright(conf));
    } else {
      return (0, _hyperhtml.default)(_templateObject2(), conf.logos.map(_showLogo.default), getSpecTitleElem(conf), getSpecSubTitleElem(conf), conf.prependW3C ? "W3C " : "", conf.textStatus, conf.dashDate, conf.publishHumanDate, !conf.isNoTrack ? (0, _hyperhtml.default)(_templateObject3()   , conf.l10n.this_version, conf.thisVersion, conf.thisVersion, conf.l10n.latest_published_version, conf.latestVersion ? (0, _hyperhtml.default)(_templateObject4(), conf.latestVersion, conf.latestVersion) : "none") : "", conf.edDraftURI ? (0, _hyperhtml.default)(_templateObject5(), conf.l10n.latest_editors_draft, conf.edDraftURI, conf.edDraftURI) : "", conf.testSuiteURI ? (0, _hyperhtml.default)(_templateObject6(), conf.testSuiteURI, conf.testSuiteURI) : "", conf.implementationReportURI ? (0, _hyperhtml.default)(_templateObject7(), conf.implementationReportURI, conf.implementationReportURI) : "", conf.bugTrackerHTML ? (0, _hyperhtml.default)(_templateObject8(), conf.l10n.bug_tracker, [conf.bugTrackerHTML]) : "", conf.isED && conf.prevED ? (0, _hyperhtml.default)(_templateObject9(), conf.prevED, conf.prevED) : "", conf.showPreviousVersion ? (0, _hyperhtml.default)(_templateObject10(), conf.prevVersion, conf.prevVersion) : "", !conf.prevRecURI ? "" : conf.isRec ? (0, _hyperhtml.default)(_templateObject11(), conf.prevRecURI, conf.prevRecURI) : (0, _hyperhtml.default)(_templateObject12(), conf.prevRecURI, conf.prevRecURI), conf.multipleEditors ? conf.l10n.editors : conf.l10n.editor, (0, _showPeople.default)(conf.editors), Array.isArray(conf.formerEditors) && conf.formerEditors.length > 0 ? (0, _hyperhtml.default)(_templateObject13(), conf.multipleFormerEditors ? conf.l10n.former_editors : conf.l10n.former_editor, (0, _showPeople.default)(conf.formerEditors)) : "", conf.authors ? (0, _hyperhtml.default)(_templateObject14(), conf.multipleAuthors ? conf.l10n.authors : conf.l10n.author, (0, _showPeople.default)(conf.authors)) : "", conf.otherLinks ? conf.otherLinks.map(_showLink.default) : "", conf.errata ? (0, _hyperhtml.default)(_templateObject15(), conf.errata) : "", conf.isRec ? (0, _hyperhtml.default)(_templateObject16(), "http://www.w3.org/2003/03/Translations/byTechnology?technology=".concat(conf.shortName)) : "", conf.alternateFormats ? (0, _hyperhtml.default)(_templateObject17(), conf.multipleAlternates ? "This document is also available in these non-normative formats:" : "This document is also available in this non-normative format:", [conf.alternatesHTML]) : "", renderCopyright(conf));
    }
  };
  /**
   * @param {string} text
   * @param {string} url
   * @param {string=} cssClass
   */


  _exports.default = _default;

  function linkLicense(text, url, cssClass) {
    return (0, _hyperhtml.default)(_templateObject18(), url, cssClass, text);
  }

  function renderCopyright(conf) {
    return conf.isUnofficial ? conf.additionalCopyrightHolders ? (0, _hyperhtml.default)(_templateObject19(), [conf.additionalCopyrightHolders]) : conf.overrideCopyright ? [conf.overrideCopyright] : (0, _hyperhtml.default)(_templateObject20(), linkLicense("Creative Commons Attribution 4.0 License", ccLicense, "subfoot")) : conf.overrideCopyright ? [conf.overrideCopyright] : renderOfficialCopyright(conf);
  }

/* EEA specStatus */
  function renderOfficialCopyright(conf) {
    if (conf.specStatus === "EEA") {
      return (0, _hyperhtml.default)(_templateObject21eea(), conf.copyrightStart ? "".concat(conf.copyrightStart, "-") : "", conf.publishYear, conf.additionalCopyrightHolders ? (0, _hyperhtml.default)(_templateObject22(), [conf.additionalCopyrightHolders]) : "", noteIfDualLicense(conf), eealegalDisclaimer, eeaTrademark, linkDocumentUse(conf));
    } else {
      return (0, _hyperhtml.default)(_templateObject21(), conf.copyrightStart ? "".concat(conf.copyrightStart, "-") : "", conf.publishYear, conf.additionalCopyrightHolders ? (0, _hyperhtml.default)(_templateObject22(), [conf.additionalCopyrightHolders]) : "", noteIfDualLicense(conf), legalDisclaimer, w3cTrademark, linkDocumentUse(conf));
    }
  }

  function noteIfDualLicense(conf) {
    if (!conf.isCCBY) {
      return;
    }

    return (0, _hyperhtml.default)(_templateObject23(), linkLicense("CC-BY", ccLicense), linkLicense("W3C Document License", w3cLicense));
  }

  function linkDocumentUse(conf) {
    if (conf.isCCBY) {
      return linkLicense("document use", "https://www.w3.org/Consortium/Legal/2013/copyright-documents-dual.html");
    }

    if (conf.isW3CSoftAndDocLicense) {
      return linkLicense("permissive document license", "https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document");
    }

/* EEA specStatus */
    if (conf.isEEA) {
      return;
    }

    return linkLicense("document use", w3cLicense);
  }
});
//# sourceMappingURL=headers.js.map